// ===================================================
// supabase.js — Supabase 클라이언트(연결 객체) 초기화
//
// 이 파일은 앱 전체에서 Supabase DB에 접근할 때 사용하는
// 연결 객체를 단 한 번 만들어 공유합니다.
// 다른 파일에서는 이 파일에서 export한 supabase 객체를 import해서 씁니다.
//
// flowType: 'pkce' — 네이티브 앱(iOS/Android)에서 구글 로그인 시
// 외부 브라우저와 앱 사이에 인증 코드를 안전하게 교환하는 방식.
// 웹에서도 동일하게 동작합니다.
// ===================================================

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Supabase 연결 객체 생성 (앱 전체에서 이 하나를 공유)
// flowType 'pkce': 외부 브라우저 OAuth 후 인증 코드를 앱으로 안전하게 전달하는 방식
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    // 세션을 localStorage에 저장 (새로고침 후에도 로그인 유지)
    persistSession: true,
    // localStorage를 명시적으로 사용 (브라우저 기본값이지만, 확실히 지정)
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    // JWT 만료 시 자동으로 refresh_token으로 갱신
    autoRefreshToken: true,
    // URL에서 인증 파라미터 자동 감지 (이메일 인증 링크 등)
    detectSessionInUrl: true,
  },
});
